exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-bordered th {\r\n  border: none;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #d8d8d8 !important;\r\n  color: #404040 !important;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: #e30613 !important;\r\n  color: #404040 !important;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n", ""]);

// exports
